import axios from "axios";
import React, { useEffect, useState } from "react";
import {useHistory } from "react-router-dom";
import swal from "sweetalert";

const ViewPage = (props) => {
    document.title = "DirtMap - Page Details";

    const history = useHistory();
   // const { id } = useParams();
    const [loading, setLoading] = useState(true);
    const [page, setPage] = useState([]);

    //console.log(id);
    useEffect(() => {
       let isMounted  = true;
        axios.get(`api/detail/cms/page/${props.match.params.id}`).then(res => {
            if(isMounted) {
                if (res.data.result) {
                    setPage(res.data.result);
                    setLoading(false);
                } else if (res.data.status === 'false') {
                    history.push('/');
                    swal("warning", res.data.message, "error");
                }
            }
            
        });
        return () => {
            isMounted = false;
        };
    }, [props.match.params.id, history]);

    if(loading) {
        return <div className="fp-container"><img src={"/images/spinner.gif"} className="fp-loader" alt="loading" /></div>;
    } else {

    }
    return (
        <main className="main">
            <div className="container-fluid">
                <div className="card shadow mb-4">
                    <div className="card-header py-3">
                        <div className="row align-items-center">
                            <div className="col-sm-12">
                                <h4 className="card-title mb-0"> Page Details</h4>
                            </div>

                        </div>
                    </div>
                    <div className="card-body">
                        <div className="table-responsive">
                            <table className="table table-bordered" width="100%">
                               
                                <tbody>
                                    <tr>
                                        <th >Title:</th>
                                        <td>{page.title}</td>
                                    </tr>
                                    <tr>
                                        <th >Url:</th>
                                        <td>{page.url}</td>
                                    </tr>
                                    <tr>
                                        <th >Slug:</th>
                                        <td>{page.slug}</td>
                                    </tr>
                                    <tr>
                                        <th >Description:</th>
                                        <td dangerouslySetInnerHTML={{ __html: page.description }}></td>
                                    </tr>
                                    <tr>
                                        <th>Status:</th>
                                        <td className="center">
                                        {page.status === '1' ? 'Active' : 'Inactive'}  
                                        </td>
                                    </tr>
                                </tbody>


                            </table>
                        </div>
                    </div>
                </div>

            </div>
        </main>
    )
}

export default ViewPage;